import logoOrange from "@/assets/logos/staffoji-logo-orange.svg";
import logoTeal from "@/assets/logos/staffoji-logo-teal.svg";
import logoBlue from "@/assets/logos/staffoji-logo-blue.svg";
import logoLime from "@/assets/logos/staffoji-logo-lime.svg";

export function AnimatedLogo() {
  return (
    <div className="relative h-12 w-auto" style={{ width: '140px' }}>
      <img 
        src={logoOrange}
        alt="Staffoji"
        className="absolute inset-0 h-full w-full object-contain animate-logo-fade-1 will-change-[opacity]"
      />
      <img 
        src={logoTeal}
        alt="Staffoji"
        className="absolute inset-0 h-full w-full object-contain animate-logo-fade-2 will-change-[opacity]"
      />
      <img 
        src={logoBlue}
        alt="Staffoji"
        className="absolute inset-0 h-full w-full object-contain animate-logo-fade-3 will-change-[opacity]"
      />
      <img 
        src={logoLime}
        alt="Staffoji"
        className="absolute inset-0 h-full w-full object-contain animate-logo-fade-4 will-change-[opacity]"
      />
    </div>
  );
}
